export default __webpack_public_path__ + "49bab72bef8f387c67c5eb596c058f8b.jpg";